import { bool, number, object, string } from "yup";
import { CHILD_AGE_REQUIRED_BEST_PRICE, DISALLOW_INFANT_INTL_FLIGHT, INFANT_CAPACITY_LIMIT, INVALID_DATES, PACKAGE_LOCATION_REQUIRED } from "../shared/validation/messages.js";
import { isLocationWithInfant } from "../shared/validation/shared-rules.js";
import { asYupResolverSchema } from "../shared/validation/yup-resolver-schema.js";
import { FLIGHT, STAY_DRIVE } from "./constants.js";
const LOCATION_REQUIRED = PACKAGE_LOCATION_REQUIRED;
const INVALID_DATE = INVALID_DATES;
const CHILD_AGE_REQUIRED = CHILD_AGE_REQUIRED_BEST_PRICE;
const TIME_RANGE_ERROR = 'Please make sure the drop-off time is later than the pick-up time.';
const hasFlight = (tripType)=>tripType.includes(FLIGHT);
const isInfantOnInternationalTravel = (startLocation, endLocation, childrenAges, tripType, shouldAllowInternationalLapInfants = false)=>{
    if (shouldAllowInternationalLapInfants) return '';
    if (hasFlight(tripType) && (isLocationWithInfant(startLocation, childrenAges) || isLocationWithInfant(endLocation, childrenAges))) return DISALLOW_INFANT_INTL_FLIGHT;
    return '';
};
function handleIsInfantOnInternationalTravel() {
    const { startLocation, endLocation, travelers, tripType } = this.parent;
    const { childrenAges } = travelers;
    return !isInfantOnInternationalTravel(startLocation, endLocation, childrenAges, tripType);
}
function handleIsChildrenAgeProvided() {
    const { childrenAges, children } = this.parent;
    if (0 === children) return true;
    const validAgesCount = Object.values(childrenAges || {}).filter((age)=>/^\d+$/.test(String(age)) && Number(age) >= 0).length;
    if (validAgesCount !== children) return this.createError({
        message: CHILD_AGE_REQUIRED,
        path: this.path
    });
    return true;
}
const isInfantLimitReachedPackages = (adults, childrenAges, tripType)=>{
    const lapInfants = Object.values(childrenAges).filter((age)=>{
        const numAge = Number.parseInt(age, 10);
        return !Number.isNaN(numAge) && 0 === numAge;
    });
    const infantCount = lapInfants.length;
    if (tripType?.includes(FLIGHT) && infantCount > adults) return INFANT_CAPACITY_LIMIT;
    return '';
};
function handleIsInfantLimitReachedPackage() {
    const { tripType, travelers } = this.parent;
    const { adults, childrenAges } = travelers;
    return !isInfantLimitReachedPackages(adults, childrenAges, tripType);
}
function handleDateCheck() {
    const formState = this.parent;
    const { tripType, startDate, endDate } = formState;
    const isError = 'FLY:DRIVE' !== tripType && startDate === endDate;
    if (isError) return this.createError({
        message: INVALID_DATE,
        path: this.path
    });
    return true;
}
const packagesSearchFormShape = object().shape({
    tripType: string(),
    partialStay: bool(),
    startLocation: object().nullable().when('tripType', {
        is: STAY_DRIVE,
        then: (schema)=>schema.nullable(),
        otherwise: (schema)=>schema.nullable().required(LOCATION_REQUIRED)
    }),
    endLocation: object().nullable().required(LOCATION_REQUIRED),
    rcLocation: object().nullable().when('pickupCarSomewhere', {
        is: true,
        then: (schema)=>schema.nullable().required(LOCATION_REQUIRED),
        otherwise: (schema)=>schema.nullable()
    }),
    startDate: string().required(INVALID_DATE).test(handleDateCheck),
    endDate: string().required(INVALID_DATE),
    hotelStartDate: string().when('partialStay', {
        is: true,
        then: (schema)=>schema.required(INVALID_DATE)
    }),
    hotelEndDate: string().when('partialStay', {
        is: true,
        then: (schema)=>schema.required(INVALID_DATE)
    }),
    rcPickupDate: string().when('pickupCarSomewhere', {
        is: true,
        then: (schema)=>schema.nullable().required(INVALID_DATE)
    }),
    rcDropoffDate: string().when('pickupCarSomewhere', {
        is: true,
        then: (schema)=>schema.nullable().required(INVALID_DATE)
    }),
    rcDropoffTime: string().when('pickupCarSomewhere', {
        is: true,
        then: (schema)=>schema.test({
                name: 'rcDropoffTime',
                message: TIME_RANGE_ERROR,
                test () {
                    const { rcPickupDate, rcDropoffDate, rcPickupTime, rcDropoffTime } = this.parent;
                    if (!rcPickupDate || !rcDropoffDate || rcPickupDate !== rcDropoffDate) return true;
                    if (!rcPickupTime || !rcDropoffTime) return true;
                    return rcDropoffTime >= rcPickupTime;
                }
            }),
        otherwise: (schema)=>schema.nullable()
    }),
    travelers: object().shape({
        children: number().test({
            name: 'children',
            test () {
                return handleIsChildrenAgeProvided.call(this);
            }
        })
    }),
    isInfantOnInternationalTravel: string().test('isInfantOnInternationalTravel', DISALLOW_INFANT_INTL_FLIGHT, handleIsInfantOnInternationalTravel),
    isInfantLimitReachedPackages: string().test('isInfantLimitReachedPackages', INFANT_CAPACITY_LIMIT, handleIsInfantLimitReachedPackage)
});
const createPackagesSearchFormSchema = (options = {})=>{
    const shape = options.shouldAllowInternationalLapInfants ? packagesSearchFormShape.shape({
        isInfantOnInternationalTravel: string().test({
            name: 'isInfantOnInternationalTravel',
            test: ()=>true
        })
    }) : packagesSearchFormShape;
    return asYupResolverSchema(shape);
};
const packagesSearchFormSchema = createPackagesSearchFormSchema();
const validation = packagesSearchFormSchema;
export { TIME_RANGE_ERROR, createPackagesSearchFormSchema, validation as default, isInfantLimitReachedPackages, isInfantOnInternationalTravel, packagesSearchFormSchema };
